/** @format */
import Cookies from "js-cookie";

export async function getDocPlanADM(token, instanceId, clientId) {
  const api_url = Cookies.get("ApiUrl"); 
  const apiUrl = `${api_url}/admin/document/list/plans`;
  try {
    const response = await fetch(apiUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: token,
      },
      body: JSON.stringify({
        InstanceId: instanceId,
        ClientId : clientId
      }),
    });
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.list;
  } catch (error) {
    throw new Error(error);
  }
}
